<template>
	<div>
		<div>
			<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
				@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
				<template #default>
					<div ref="logistictrace_custom_form"></div>
				</template>
				<template #footer>
					<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
					<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
				</template>
			</vxe-modal>
		</div>
		<jindieextra ref="transferaccountsjindieextra" :type="type" :obj="obj" @submit="jindieSubmit" />
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "500",
			"fApi": [],
			"rule": [{
					"type": "$select",
					"field": "FBillTypeID",
					"title": "单据类型",
					"props": {
						"readonly": false
					},
					"options": [{
						"value": "XJCQ01_SYS",
						"label": "存款"
					}, {
						"value": "XJCQ02_SYS",
						"label": "取款"
					}],
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},{
					"type": "$inputButton",
					"field": "FBANKACNTID",
					"title": "银行账号",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "FBANKACNTID_FNumber",
					"title": "银行账号ID",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}, {
					"type": "$input",
					"field": "FBANKID",
					"title": "开户银行",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "FBANKID_FNumber",
					"title": "开户银行ID",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},{
					"type": "$inputButton",
					"field": "FCashAccount",
					"title": "现金账号",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "FCashAccount_FNumber",
					"title": "现金账号ID",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},

				{
					"type": "$input",
					"field": "FEXPLANATION",
					"title": "摘要",
					"props": {
						"readonly": false
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 12,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import jindieextra from './box/jindieextra.vue'
	// import BDExpense from '../box/BD_Expense.vue'
	// import BDSETTLETYPE from '../box/BD_SETTLETYPE.vue'
	// import CNRECPAYPURPOSE from '../box/CN_RECPAYPURPOSE.vue'
	// import BDAccount from '../box/BD_Account.vue'
	// import BASPreBaseDataOne from '../box/BAS_PreBaseDataOne.vue'

	export default {
		mixins: [modalMixins],
		props: {
			tabledata: {
				default: () => {
					return []
				}
			},
			maindata: {
				default: () => {
					return null
				}
			},
			jindierequire: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '现金存取必填项',
				modal_width: 800,
				modal_height: 600,
				obj: null,
				type: [],
				field: null,
				formtype: null,
				FCONTACTUNITTYPE: null,
				loading: false
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
					this.bankacc2jindie()
					this.data2jindie()
				})
				this.$emit('show')
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			setFormData() {
				let jindierequire = this.parseJson()
				if (jindierequire) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, jindierequire.main[item])
					})
				}
			},
			bankacc2jindie() {
				//console.log(this.fApi.getValue('FBANKACNTID'),this.fApi.getValue('FCashAccount'))
				if (!this.fApi.getValue('FBANKACNTID') && !this.fApi.getValue('FCashAccount')) {
					this.loading = true
					this.$api.transferaccounts.jindieextra({
						type: ['CN_BANKACNT','CN_CASHACCOUNT']
					}).then((res) => {
						console.log(res,this.maindata)
						let payobj = res.find((item) => {
							return item.FNumber == this.maindata.payAcc
						})
						if (payobj) {
							if(payobj.ModuleType == 'CN_BANKACNT'){
								this.fApi.setValue('FBANKACNTID', payobj.FNumber)
								this.fApi.setValue('FBANKACNTID_FNumber', payobj.FNumber)
								this.fApi.setValue('FBANKID', payobj.FBANKID)
								this.fApi.setValue('FBANKID_FNumber', payobj.FBANKID)
								this.fApi.setValue('FBillTypeID', 'XJCQ02_SYS')
							}else{
								this.fApi.setValue('FCashAccount', payobj.FNumber)
								this.fApi.setValue('FCashAccount_FNumber', payobj.FNumber)
								this.fApi.setValue('FBillTypeID', 'XJCQ01_SYS')
							}
						}
						let rcvobj = res.find((item) => {
							return item.FNumber == this.maindata.rcvAcc
						})
						if (rcvobj) {
							if(rcvobj.ModuleType == 'CN_BANKACNT'){
								this.fApi.setValue('FBANKACNTID', rcvobj.FNumber)
								this.fApi.setValue('FBANKACNTID_FNumber', rcvobj.FNumber)
								this.fApi.setValue('FBANKID', rcvobj.FBANKID)
								this.fApi.setValue('FBANKID_FNumber', rcvobj.FBANKID)
								this.fApi.setValue('FBillTypeID', 'XJCQ01_SYS')
							}else{
								this.fApi.setValue('FCashAccount', rcvobj.FNumber)
								this.fApi.setValue('FCashAccount_FNumber', rcvobj.FNumber)
								this.fApi.setValue('FBillTypeID', 'XJCQ02_SYS')
								
							}
						}

						this.loading = false
					}, () => {
						this.loading = false
					})
				}
			},
			data2jindie() {
				if (!this.fApi.getValue('FEXPLANATION')) {
					this.fApi.setValue('FEXPLANATION', this.maindata.mark)
				}
			},
			jindieBoxShow(obj, type, field, formtype) {
				this.obj = obj
				this.type = type
				this.field = field
				this.formtype = formtype
				this.$refs.transferaccountsjindieextra.initList()
				this.$refs.transferaccountsjindieextra.box.alertBox()
			},
			FBANKACNTIDButton() {
				let type = ['CN_BANKACNT']
				let obj = this.fApi.formData()
				this.jindieBoxShow(obj, type, 'FBANKACNTID', 'main')
			},
			FCashAccountButton() {
				let type = ['CN_CASHACCOUNT']
				let obj = this.fApi.formData()
				this.jindieBoxShow(obj, type, 'FCashAccount', 'main')
			},
			jindieSubmit(e) {
				console.log(this.field, e.data)
				if (this.field == 'FBANKACNTID') {
					this.fApi.setValue(this.field, e.data.FNumber)
					this.fApi.setValue(this.field + '_FNumber', e.data.FNumber)
					this.fApi.setValue('FBANKID', e.data.FBANKID)
					this.fApi.setValue('FBANKID_FNumber', e.data.FBANKID)
				}
				if (this.field == 'FCashAccount') {
					this.fApi.setValue(this.field, e.data.FNumber)
					this.fApi.setValue(this.field + '_FNumber', e.data.FNumber)
				}
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					let data = {}
					data.main = submitData
					this.createJson(data)
					this.$emit('success', {
						data: JSON.stringify(data)
					})
					this.modal_cancel()
					console.log(data)
				})
			},
			clear() {
				this.$confirm('是否确认清空', '提示').then(() => {
					this.$emit('clear')
					this.modal_cancel()
				})
			},
			bathedit() {

			},
			createJson(data) {
				console.log(data, 123123)
				let json = {}
				let Model = {}
				for (let i in data.main) {
					if (!i.includes('FNumber')) {
						if (data.main[i + '_FNumber']) {
							Model[i] = {
								FNumber: data.main[i + '_FNumber']
							}
						} else {
							Model[i] = data.main[i]
						}
					}
				}
				json.Model = Model
				data.json = json
			},
			parseJson() {
				return this.jindierequire ? JSON.parse(this.jindierequire) : null
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			jindieextra,
			// BDExpense,
			// BDSETTLETYPE,
			// CNRECPAYPURPOSE,
			// BDAccount,
			// BASPreBaseDataOne
		}
	}
</script>